module.exports = __webpack_public_path__ + "static/map-18eeab50e6264daad986bfc75019aa48.jpg";